import React from 'react';
import { Route, Switch } from 'react-router-dom';
import TrackPageView from './components/TrackPageView'; // Import the page view tracking component
import Koti from './pages/Etusivu';
import Kurssit from './pages/Kurssit';
import Romania from './pages/Romania';
import Meistä from './pages/Meistä';
import Yhteistiedot from './pages/Yhteistiedot';
import Tentti from './pages/Tentti';
import LääkeRomania from './pages/LääkeRomania';

const App = () => {
  return (
      <>
        <TrackPageView />
        <Switch>
          <Route path="/LääketiedeRomaniassa" component={LääkeRomania} />
          <Route path="/Tenttivaatimukset" component={Tentti} />
          <Route path="/Kurssit" component={Kurssit} />
          <Route path="/Romania" component={Romania} />
          <Route path="/Meistä" component={Meistä} />
          <Route path="/Yhteistiedot" component={Yhteistiedot} />
          <Route path="/" component={Koti} />
        </Switch>
      </>
  );
};

export default App;


